import React, { FC } from 'react';

import { Stack } from '@chakra-ui/layout';

import { CardProps } from './Card.props';

const CardView: FC<CardProps> = (props) => {
  const { row = false, children, ..._props } = props;

  const direction = row ? 'row' : 'column';

  return (
    <Stack
      p={4}
      bg="#fff"
      borderRadius="5px"
      boxShadow="0 0 30px 0 #0001"
      flexDirection={direction}
      {..._props}>
      {children}
    </Stack>
  );
};

export default CardView;
